module.exports = __webpack_public_path__ + "img/2.89a5a4ac.jpg";